import type { NavigationCounts } from '@risksmart-app/trpc/src/types';
import type {
  GetRiskCountQuery,
  Risk_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { COUNT_STALE_TIME_MS, createQueryHook } from 'src/utils';

import type { NavigationCountArgs } from '../navigation/navigationCounts';
import {
  navigationCountsQueryOptions,
  toAggregate,
} from '../navigation/navigationCounts';

type RiskCountArgs = NavigationCountArgs & {
  // The equivalent Hasura bool_exp — drives the GraphQL fallback path so the
  // flag-gated twin counts identically. Built by useEntityWhereFilter.
  where?: Risk_Bool_Exp;
};

export const useGetRiskCount = createQueryHook<
  RiskCountArgs,
  NavigationCounts,
  GetRiskCountQuery
>({
  trpcQueryOptions: navigationCountsQueryOptions,
  mapTrpcDataToGraphQL: (data) => ({
    risk_aggregate: { aggregate: toAggregate(data.risk) },
  }),
  // Aggregate over a register; mutations invalidate it. See COI-882.
  trpcStaleTime: COUNT_STALE_TIME_MS,
  graphqlDocument: GetRiskCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
